import { Ambiente, ElegibilidadeRenovaConfig, Params } from './elegibilidade-renova.types';

const configDefault: ElegibilidadeRenovaConfig = {
  minhaRenovacao: {
    marcas: ['estacio', 'wyden', 'ibmec', 'idomed'],
    tiposCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    situacoesAluno: ['ATIVO', 'EM RENOVAÇÃO'],
  },
  alteracaoGrade: {
    blocklist: [
      { marca: ['idomed'] },
      { tipoCurso: ['ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'] },
      { marca: ['unitoledo'], modalidade: ['PRESENCIAL'] },
      { marca: ['estacio'], modalidade: ['AO VIVO'] },
      { codigoCurso: ['51'] },
      { safra: ['CALOURO'] },
      { campusId: [5201, 5202] },
    ],
  },
};

const configsPorAmbiente: Record<Ambiente, ElegibilidadeRenovaConfig> = {
  dev: configDefault,
  prd: configDefault,
  hml: configDefault,
  local: configDefault,
};

export const getElegibilidadeRenovaConfig = ({ ambiente }: Params): ElegibilidadeRenovaConfig =>
  configsPorAmbiente[ambiente];
